import React from 'react';
import { features } from './data';
import './Styles/Features.scss';

const Features=()=>{
    return(
        <div className="feature-hub">
         <ul>
             {features.map((item) =>{
                 return(
                     <li>
                         <div className="line"></div>
                         <div className="circle">
                             <img src={item.icon} />
                         </div>
                             <h2>{item.title}</h2>
                             <p>{item.desc}</p>
                     </li>
                 )
             })}
         </ul>
        </div>
    )
};
export default Features ;